import React, { Component } from "react";

import TableCustom from "./TableCustom";

export class VVR_NR extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.data.length ? (
          <TableCustom
            data={this.props.data[1]}
            labels={this.props.labelsNR}
            dateEnd={this.props.dateEnd}
          />
        ) : null}
      </>
    );
  }
}

export default VVR_NR;
